<template>
  <div class="publish-article-page">
    <div class="publish-article-card">
      <!-- 频道选择 -->
      <div class="publish-article-category">
        <label class="publish-article-label">选择频道</label>
        <div class="publish-article-tag-list">
          <div
            v-for="channel in channelList"
            :key="channel.id"
            class="publish-article-tag"
            :class="{ 'publish-article-tag--selected': form.categoryIds.includes(channel.id) }"
            @click="toggleChannel(channel.id)"
          >
            {{ channel.name }}
          </div>
        </div>
      </div>

      <!-- 分隔线 -->
      <div class="publish-article-divider" />

      <!-- 标题行 -->
      <div class="publish-article-title-row">
        <input
          v-model="form.title"
          class="publish-article-title-input"
          type="text"
          placeholder="输入文章标题...限制 80 个字符"
          maxlength="80"
          @input="handleTitleInput"
        />
        <button class="publish-article-check-btn" @click="checkTitleDuplicate">
          检测标题是否重复
        </button>
      </div>

      <!-- 副标题 -->
      <input
        v-model="form.subtitle"
        class="publish-article-subtitle-input"
        type="text"
        placeholder="副标题 (可选)...限制 80 个字符"
        maxlength="80"
        @input="handleSubtitleInput"
      />

      <!-- 摘要 -->
      <div class="publish-article-summary">
        <textarea
          v-model="form.summary"
          class="publish-article-summary-input"
          placeholder="请输入摘要内容"
          maxlength="400"
          rows="3"
        />
        <div class="publish-article-summary-count">
          还可以输入{{ summaryRemaining }}个字符
        </div>
      </div>

      <!-- 数据来源 -->
      <div class="publish-article-source">
        <label class="publish-article-label">数据来源</label>
        <div class="publish-article-radio-group">
          <label class="publish-article-radio">
            <input
              type="radio"
              name="source"
              value="原创"
              v-model="form.source"
              @change="handleSourceChange"
            />
            <span>原创</span>
          </label>
          <label class="publish-article-radio">
            <input
              type="radio"
              name="source"
              value="转载"
              v-model="form.source"
              @change="handleSourceChange"
            />
            <span>转载</span>
          </label>
        </div>
        <div v-if="form.source === '转载'" class="publish-article-original-input">
          <input
            v-model="form.originalSource"
            type="text" maxlength="30"
            placeholder="请输入转载来源"
          />
        </div>
      </div>

      <!-- 分隔线 -->
      <div class="publish-article-divider" />

      <!-- 富文本编辑器 -->
      <div class="publish-article-editor">
        <Toolbar
          class="publish-article-toolbar"
          :editor="editor"
          :default-config="toolbarConfig"
          mode="default"
        />
        <Editor
          v-model="form.content"
          class="publish-article-editor-content"
          :default-config="editorConfig"
          :default-html="defaultHtml"
          mode="default"
          @onCreated="onEditorCreated"
        />
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="publish-article-actions">
      <!-- <button
        class="publish-article-btn publish-article-btn--view-html"
        @click="viewHtml"
      >
        查看 HTML
      </button> -->
      <button
        class="publish-article-btn publish-article-btn--submit"
        :disabled="!canSubmit"
        :class="{ 'publish-article-btn--disabled': !canSubmit }"
        @click="handleSubmit"
      >
        提交
      </button>
    </div>

    <!-- HTML 预览对话框 -->
    <div v-if="showHtmlModal" class="dialog-overlay" @click.self="showHtmlModal = false">
      <div class="dialog-content">
        <h3>HTML 代码</h3>
        <textarea
          v-model="editingHtmlContent"
          placeholder="在此编辑 HTML 代码..."
          rows="20"
        ></textarea>
        <div class="dialog-buttons">
          <button @click="saveHtmlFromModal">确定</button>
          <button @click="showHtmlModal = false">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { BASE_URL, fetchNewsContent, checkNewsTitle, submitNewsAudit, getCategoryList } from '../../api'

export default {
  name: 'PublishArticle',
  components: {
    Editor,
    Toolbar
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    authStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      editor: null,
      defaultHtml: '<p><br></p>',
      userType: localStorage.getItem('userType') || 'personal',
      userName: '', // 用户昵称
      showHtmlModal: false, // 是否显示 HTML 弹窗
      htmlContent: '', // HTML 内容
      editingHtmlContent: '', // 编辑中的 HTML 内容
      channelList: [],     // 频道列表
      form: {
        title: '',
        subtitle: '',
        summary: '',
        content: '',
        categoryIds: [],     // 频道 ID 数组
        source: '',          // 数据来源：原创/转载
        originalSource: ''   // 转载来源
      },
      toolbarConfig: {
        // 使用 excludeKeys 排除视频相关功能
        excludeKeys: [
          'group-video'
        ]
      },
      editorConfig: {
        placeholder: '在这里开始写作...',
        autoFocus: false,
        MENU_CONF: {
          // 禁用视频功能
          uploadVideo: { server: '', fieldName: '', headers: {} },
          insertVideo: { server: '' },
          uploadImage: {
            server: `${BASE_URL}/api/common/uploadFile/picFileWithWatermark`,
            fieldName: 'file',
            headers: {
              token: localStorage.getItem('token') || ''
            },
            customInsert(res, insertFn) {
              const url = res.data || ''
              if (!url) {
                Toast('图片上传失败')
                return
              }
              insertFn(url, '', url)
            }
          }
        }
      }
    }
  },
  computed: {
    summaryRemaining() {
      return 400 - (this.form.summary ? this.form.summary.length : 0)
    },
    selectedChannelNames() {
      if (!this.channelList.length) return []
      return this.channelList.filter(channel => 
        this.form.categoryIds.includes(channel.id)
      )
    },
    canSubmit() {
     
      return this.authStatus === 2
    }
  },
  created() {
    if (this.id) {
      this.loadArticleDetail()
    } else {
      this.loadChannelList()
    }
  },
  mounted() {
    if (!this.id) {
      this.$emit('loaded')
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()
      this.editor = null
    }
  },
  methods: {
    onEditorCreated(editor) {
      this.editor = editor
    },
    handleSourceChange() {
      // 当切换数据来源时，处理后续逻辑
      if (this.form.source === '原创') {
        this.form.originalSource = ''
      }
    },
    async loadChannelList() {
      try {
        const list = await getCategoryList(this.userType === 'personal' ? 1 : 2)
        this.channelList = list
      } catch (err) {
        console.error('获取频道列表失败:', err)
      }
      // 获取用户昵称
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        const userInfo = JSON.parse(userInfoStr || '{}')
        this.userName = userInfo.nickname || userInfo.lastName || ''
      } catch (err) {
        console.error('获取用户昵称失败:', err)
      }
    },
    // 查看 HTML 代码
    viewHtml() {
      if (!this.editor) {
        Toast('编辑器加载中，请稍后再试')
        return
      }
      this.htmlContent = this.editor.getHtml()
      this.editingHtmlContent = this.htmlContent
      this.showHtmlModal = true
    },
    // 保存编辑后的 HTML
    saveHtmlFromModal() {
      console.log('Saving HTML:', this.editingHtmlContent)
      if (!this.editor) {
        Toast('编辑器不可用')
        return
      }
      // 使用 Vue.$nextTick 确保响应式更新
      this.form.content = this.editingHtmlContent
      this.showHtmlModal = false
      
      // 延迟调用 setHtml 确保编辑器正确渲染
      this.$nextTick(() => {
        if (this.editor) {
          try {
            this.editor.setHtml(this.editingHtmlContent)
            console.log('HTML saved successfully')
          } catch (err) {
            console.error('setHtml error:', err)
          }
        }
      })
    },
    // 切换频道选择
    toggleChannel(channelId) {
      const index = this.form.categoryIds.indexOf(channelId)
      if (index > -1) {
        // 取消选择
        this.form.categoryIds.splice(index, 1)
      } else {
        // 选择
        this.form.categoryIds.push(channelId)
      }
    },
    async loadArticleDetail() {
      try {
        const data = await fetchNewsContent(this.id)
        this.form.title = data.title || ''
        this.form.subtitle = data.subtitle || ''
        this.form.summary = data.summary || ''
        this.form.content = data.content || ''
        this.$emit('loaded')
      } catch (err) {
        Toast(err.message || '获取文章详情失败')
        this.$emit('load-error')
      }
    },
    /** 标题输入长度限制（英文数字占 1 字符，汉字占 2 字符） */
    handleTitleInput() {
      this.form.title = this.limitCharLength(this.form.title, 80)
    },
    /** 副标题输入长度限制（英文数字占 1 字符，汉字占 2 字符） */
    handleSubtitleInput() {
      this.form.subtitle = this.limitCharLength(this.form.subtitle, 80)
    },
    /** 按字符权重截断字符串（英文数字占 1，汉字占 2） */
    limitCharLength(str, maxLen) {
      if (!str) return str
      let len = 0
      let i = 0
      for (; i < str.length; i++) {
        const charLen = str.charCodeAt(i) > 127 ? 2 : 1
        if (len + charLen > maxLen) break
        len += charLen
      }
      return str.substring(0, i)
    },
    async checkTitleDuplicate() {

      const title = this.form.title.trim()
      if (!title) {
        Toast('请输入文章标题')
        return
      }
      try {
        // 传递 id 参数（编辑模式下）
        const isDuplicate = await checkNewsTitle(title, this.userType, this.id)
        if (isDuplicate) {
          Toast('该标题已存在')
        } else {
          Toast('该标题可用')
        }
      } catch (err) {
        Toast(err.message || '标题检测失败')
      }
    },
    async handleSubmit() {
      if (!this.form.categoryIds || this.form.categoryIds.length === 0) {
        Toast('请选择频道')
        return
      }
      const title = this.form.title.trim()
      const summary = this.form.summary.trim()
      const content = this.form.content.trim()
      if (!title) {
        Toast('请输入文章标题')
        return
      }
      if (!summary) {
        Toast('请输入摘要')
        return
      }
      if (!content) {
        Toast('请输入文章内容')
        return
      }
      if (!this.canSubmit) {
        Toast(this.userType === 'company' ? '没有进行企业认证无法发布文章' : '没有进行实名认证无法发布文章')
        return
      }
      
      // 在提交前调用接口检测标题是否重复
      try {
        const isDuplicate = await checkNewsTitle(title, this.userType, this.id)
        if (isDuplicate) {
          Toast('该标题已存在，请更换标题')
          return
        }
      } catch (err) {
        Toast(err.message || '标题检测失败')
        return
      }
      
      const params = {
        title,
        subtitle: this.form.subtitle.trim(),
        summary,
        content,
        categoryIds: this.form.categoryIds,  // 频道 ID 数组
        source: this.getSourceString()       // 数据来源
      }
      if (this.id) {
        params.id = this.id
      }
      try {
        await submitNewsAudit(params, this.userType)
        Toast('文章提交成功')
        this.resetForm()
        this.$emit('submit-success')
      } catch (err) {
        Toast(err.message || '文章提交失败')
      }
    },
    resetForm() {
      this.form = {
        title: '',
        subtitle: '',
        summary: '',
        content: '',
        categoryIds: [],
        source: '',
        originalSource: ''
      }
      if (this.editor) {
        this.editor.clear()
      }
    },
    getSourceString() {
      if (!this.form.source) return ''
      if (this.form.source === '原创') {
        return `${this.userName}|原创`
      } else if (this.form.source === '转载') {
        // 如果是转载，返回"输入内容 | 转载"
        return `${this.form.originalSource || ''}|转载`
      }
      return ''
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style>
.publish-article-editor-content .w-e-text-container {
  min-height: 400px;
}
.publish-article-editor-content .w-e-text-container [data-slate-editor] {
  font-size: 12px;
  min-height: 400px;
}
.publish-article-editor-content .w-e-text-container [data-slate-editor] p {
  font-size: 12px;
}
</style>
<style scoped>
.publish-article-page {
  padding: 20px;
  background: #F5F7FA;
  min-height: calc(100vh - 64px);
}

.publish-article-card {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 24px 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.publish-article-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.publish-article-title-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 22px;
  font-weight: 600;
  color: #333333;
  background: transparent;
}

.publish-article-title-input::placeholder {
  color: #BFBFBF;
}

.publish-article-check-btn {
  flex-shrink: 0;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  background: #FFFFFF;
  color: #666666;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.publish-article-check-btn:hover {
  border-color: #23B4DC;
  color: #23B4DC;
}

.publish-article-subtitle-input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 16px;
  color: #333333;
  background: transparent;
  margin-bottom: 20px;
}

.publish-article-subtitle-input::placeholder {
  color: #BFBFBF;
}

/* ========== 数据来源 ==========
 */
.publish-article-source,
.publish-article-category {
  margin-bottom: 24px;
}

.publish-article-label {
  display: block;
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
  font-weight: 500;
  margin-bottom: 12px;
}

.publish-article-radio-group {
  display: flex;
  gap: 32px;
  margin-bottom: 8px;
}

.publish-article-radio {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}

.publish-article-radio input[type="radio"] {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
  accent-color: #23B4DC;
}

.publish-article-original-input {
  margin-top: 12px;
  margin-left: 24px;
}

.publish-article-original-input input {
  width: calc(100% - 24px);
  border: none;
  outline: none;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  background: transparent;
  padding: 0;
}

.publish-article-original-input input::placeholder {
  color: #BFBFBF;
}

.publish-article-summary {
  position: relative;
  margin-bottom: 20px;
}

.publish-article-summary-input {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font-size: 14px;
  color: #333333;
  line-height: 1.6;
  background: transparent;
}

.publish-article-summary-input::placeholder {
  color: #BFBFBF;
}

.publish-article-summary-count {
  text-align: right;
  font-size: 13px;
  color: #999999;
  margin-top: 6px;
}

/* ========== 频道选择 ==========
 */
.publish-article-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px;
}

.publish-article-tag {
  display: inline-block;
  padding: 8px 20px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  background: rgba(245, 247, 250, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.publish-article-tag:hover {
  background: rgba(35, 180, 220, 0.1);
  border-color: #23B4DC;
  color: #23B4DC;
}

.publish-article-tag--selected {
  background: #23B4DC;
  border-color: #23B4DC;
  color: rgba(255, 255, 255, 1);
  font-weight: 500;
  opacity: 0.95; /* 确保文字不透明度 */
}

.publish-article-tag--selected:hover {
  background: #1CA3C9;
  border-color: #1CA3C9;
  color: rgba(255, 255, 255, 1); /* 明确白色文字 */
  opacity: 0.9;
}

.publish-article-divider {
  height: 1px;
  background: #E8E8E8;
  margin-bottom: 16px;
}

.publish-article-editor {
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  overflow: hidden;
}

.publish-article-toolbar {
  border-bottom: 1px solid #E8E8E8;
}

.publish-article-editor-content {
  min-height: 400px;
}

.publish-article-actions {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 32px;
}

.publish-article-btn {
  width: 140px;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.publish-article-btn--submit {
  background: #23B4DC;
  color: #FFFFFF;
}

.publish-article-btn--view-html {
  background: #FFFFFF;
  color: #666666;
  border: 1px solid #D9D9D9;
}

.publish-article-btn--submit:hover {
  background: #1CA3C9;
}

.publish-article-btn--disabled,
.publish-article-btn--disabled:hover {
  background: #CCCCCC;
  color: #FFFFFF;
  cursor: not-allowed;
}

/* HTML 模态框样式 */
.html-content textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  min-height: 400px;
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  font-size: 12px;
  white-space: pre;
  word-break: break-all;
  resize: vertical;
}

/* 自定义 Dialog 样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.dialog-content {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  max-width: 800px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-content h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  color: #333;
  flex-shrink: 0;
}

.dialog-content textarea {
  flex: 1;
  min-height: 400px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
  font-size: 14px;
  white-space: pre;
  word-break: break-all;
  resize: vertical;
}

.dialog-buttons {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-shrink: 0;
}

.dialog-buttons button {
  padding: 8px 20px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.dialog-buttons button:first-child {
  background: #23B4DC;
  color: #fff;
}

.dialog-buttons button:first-child:hover {
  background: #1CA3C9;
}

.dialog-buttons button:last-child {
  background: #f5f5f5;
  color: #666;
}

.dialog-buttons button:last-child:hover {
  background: #e8e8e8;
}
</style>
